export const OBJECT_TYPES = process.env.REACT_APP_OBJECT_TYPES?.split(',') || ['POI'];

export default OBJECT_TYPES;
